module.exports = __webpack_public_path__ + "static/sport/form-bg.20d46a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/football/pc/form-bg.png
// module id = k2FX
// module chunks = 0